import * as admin from "./admin";
import * as auth from "./auth";
import * as user from "./user";
import * as interactions from "./interactions";
import * as department from "./department";
import * as team from "./team";
import * as comments from "./comments";
import * as ticket_responses from "./ticket_responses";
import * as drafts from "./drafts";
import * as history from "./history";
import * as unit from "./unit";
import * as trainings from "./trainings.js";
import * as organization from "./organization.js";
import * as analytics from "./analytics.js";
import * as counts from "./counts.js";
import * as interaction_tags from "./interaction_tags";
import * as role from "./role";
import * as happinesScore from "./happiness_score";
import * as survey from "./survey";
import * as messenger from "./messenger";
import * as wfb from "./wfb";
import * as search from "./search";
import * as web_search_topic from "./web_search_topic";
import * as feature_activation_request from "./feature_activation_request";
import * as broadcasts from "./broadcasts";
import * as connect from "./connect";

export default {
  admin,
  analytics,
  auth,
  comments,
  counts,
  department,
  drafts,
  happinesScore,
  history,
  interactions,
  interaction_tags,
  organization,
  role,
  survey,
  search,
  team,
  ticket_responses,
  trainings,
  unit,
  user,
  messenger,
  wfb,
  web_search_topic,
  feature_activation_request,
  broadcasts,
  connect,
};
